import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { ToastContainer } from 'react-toastify';

export class Layout extends Component {
    render() {
        return (
            (window.location.href.includes("/login") || window.location.href.includes("/register") || window.location.href.includes("/remember")) ?
                <div className="nk-main ">
                    <div className="nk-wrap nk-wrap-nosidebar">
                        <ToastContainer
                            position="top-center"
                            autoClose={2500}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={true}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="dark"
                        />
                       {this.props.children}
                    </div>
                </div>
                :
                <div style={{"height": "100%", "min-height": "100%", "padding-top": "65px"}}>
                    <ToastContainer
                        position="top-center"
                        autoClose={2500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={true}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                    />
                    <NavMenu />
                    <div style={{ "height": "100%", "min-height": "100%" }}>
                        {this.props.children}
                    </div>
                    <div id="appStatusBarContainer">
                        <div className="appStatusBar">
                            <span><i className="fa fa-plus"></i> F2 فرم جدید</span>
                            <span><i className="fa fa-close"></i> Esc بستن فرم</span>
                            <span><i className="fa fa-save"></i> F4 ذخیره فرم</span>
                        </div>
                        <div className="appStatusBar">
                            <spa>نسخه: 2024.12.24.1</spa>
                        </div>
                    </div>
                </div>
        );
    }
}